import api from "../services/api";

export async function getTransportMotor(id) {
  return await api.get("/TransportMotor/GetEditModel", {
    params: {
      id: id,
    },
  });
}
